module.exports = __webpack_public_path__ + "static/BT1-operation-d91198c2fc339ca809475eeafe72ff54.png";